import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import moment from 'moment';
import http from "@/plugins/axios";
import store from '@/store';
var VERSION = '/v2';
export default {
  listarContrato: function listarContrato(params) {
    var empresa = store.state.auth.empresa;
    return http.apiEmpresa.get("".concat(empresa.url_instancia).concat(VERSION, "/contrato"), {
      params: params
    });
  },
  buscarContrato: function buscarContrato(id) {
    var empresa = store.state.auth.empresa;
    return http.apiEmpresa.get("".concat(empresa.url_instancia).concat(VERSION, "/contrato/").concat(id));
  },
  getParcelas: function getParcelas(params) {
    var empresa = store.state.auth.empresa;
    return http.apiEmpresa.get("".concat(empresa.url_instancia).concat(VERSION, "/parcela"), {
      params: params
    });
  },
  /**
   * Retorna o status de um contrato com base no status do contrato e dos pagamentos.
   * 
   * - ATRASADO
   * - CANCELADO
   * - EM_ATRASO
   * - EM_DIA
   * - PENDENTE
   * - VENCE_HOJE
   * 
   * @param {Object} contrato o contrato.
   * @param {Array} parcelas a lista de parcelas do contrato.
   * @returns o status do contrato.
   */
  getStatusContrato: function getStatusContrato(contrato, parcelas) {
    parcelas = parcelas || [];
    if (!contrato) {
      return null;
    }
    if (contrato.status != 'ATIVO') {
      return contrato.status;
    }
    var primeiraParcelaPendente = parcelas.find(function (parcela) {
      return parcela.status == 'PENDENTE';
    });
    if (!primeiraParcelaPendente) {
      return contrato.status;
    }
    var vencimento = moment(primeiraParcelaPendente.data_vencimento);
    var diasDeAtraso = moment().startOf('day').diff(vencimento, 'days');
    if (diasDeAtraso === 0) {
      return 'VENCE_HOJE';
    } else if (diasDeAtraso < 0) {
      return 'EM_DIA';
    } else {
      return 'ATRASADO';
    }
  },
  /**
   * Sincroniza as parcelas de um contrato com a API.
   * Aciona a sincronização no worker viavarejo-async para atualizar
   * os dados de parcelas da API Parcela.
   *
   * @param {string|number} contratoId o ID do contrato a sincronizar
   * @returns {Promise} promise da requisição POST para sincronização
   */
  sincronizarContrato: function sincronizarContrato(contratoId) {
    var empresa = store.state.auth.empresa;
    return http.apiEmpresa.post("".concat(empresa.url_instancia).concat(VERSION, "/contrato/").concat(contratoId, "/sincronizar"));
  },
  /**
   * Checa o status da sincronização de um contrato com a API.
   *
   * @param {string} task_token o token da tarefa de sincronização
   */
  checkStatus: function checkStatus(task_token) {
    var empresa = store.state.auth.empresa;
    return http.apiEmpresa.get("".concat(empresa.url_instancia).concat(VERSION, "/tarefas/status"), {
      params: {
        task_token: task_token
      }
    });
  }
};